var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F4F8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 30,
    fill: "#E7F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0013 21.6667C29.8763 21.6667 21.668 29.8751 21.668 40.0001C21.668 50.1251 29.8763 58.3334 40.0013 58.3334C50.1263 58.3334 58.3346 50.1251 58.3346 40.0001C58.3346 29.8751 50.1263 21.6667 40.0013 21.6667ZM38.1546 34.8917C38.538 34.1367 38.8213 33.7784 39.0563 33.5917C39.233 33.4517 39.473 33.3334 40.0013 33.3334C41.043 33.3334 41.668 34.1167 41.668 34.9634C41.668 35.4267 41.578 35.6567 41.3313 35.9501C40.9863 36.3601 40.348 36.8584 39.0846 37.6934L38.3346 38.1867V41.6667C38.3346 42.1088 38.5102 42.5327 38.8228 42.8453C39.1354 43.1578 39.5593 43.3334 40.0013 43.3334C40.4433 43.3334 40.8673 43.1578 41.1798 42.8453C41.4924 42.5327 41.668 42.1088 41.668 41.6667V39.9717C42.5713 39.3484 43.3296 38.7517 43.8796 38.0984C44.6746 37.1551 45.0013 36.1484 45.0013 34.9634C45.0013 32.5134 43.113 30.0001 40.0013 30.0001C38.8613 30.0001 37.853 30.2934 36.988 30.9784C36.1813 31.6167 35.6313 32.4951 35.1813 33.3867C35.0767 33.5825 35.0123 33.7972 34.9919 34.0182C34.9714 34.2392 34.9953 34.4621 35.0621 34.6738C35.1289 34.8854 35.2373 35.0816 35.381 35.2508C35.5247 35.42 35.7007 35.5587 35.8987 35.659C36.0968 35.7592 36.3128 35.8189 36.5342 35.8345C36.7556 35.8501 36.9779 35.8213 37.1881 35.7499C37.3982 35.6784 37.5919 35.5657 37.7579 35.4183C37.9239 35.271 38.0588 35.0919 38.1546 34.8917ZM41.668 47.5001C41.668 47.0581 41.4924 46.6341 41.1798 46.3216C40.8673 46.009 40.4433 45.8334 40.0013 45.8334C39.5593 45.8334 39.1354 46.009 38.8228 46.3216C38.5102 46.6341 38.3346 47.0581 38.3346 47.5001V48.3334C38.3346 48.7754 38.5102 49.1994 38.8228 49.5119C39.1354 49.8245 39.5593 50.0001 40.0013 50.0001C40.4433 50.0001 40.8673 49.8245 41.1798 49.5119C41.4924 49.1994 41.668 48.7754 41.668 48.3334V47.5001Z",
    fill: "#2246DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoQuestion);
export default __webpack_public_path__ + "static/media/icon_info_question.7b70ee1cc9d4fedb35b498b5c301b1bd.svg";
export { ForwardRef as ReactComponent };